"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.videoWrapperStyles = void 0;
const videoWrapperStyles = ({ pillarBox, fullScreen, mirror, elementBlur, blurPixels, }) => {
    // Base Styles
    let root = {
        width: "100%",
        lineHeight: 0,
    };
    let videoElement = {
        width: "100%",
        height: "100%",
        // rotate: "90deg",
        backgroundColor: "black",
        filter: elementBlur ? `blur(${blurPixels}px)` : null,
    };
    // VideoEl Styles
    const videoElPillarBox = {
        position: "absolute",
        transform: mirror ? "rotateY(180deg)" : "rotateY(0deg)",
        "&:before": {
            display: "block",
            content: '""',
            paddingTop: "0",
            paddingRight: "0",
            paddingLeft: "0",
        },
        "&::-webkit-media-controls": {
            display: "none",
            "-webkit-appearance": "none",
        },
        "&::-webkit-media-controls-play-button": {
            display: "none",
            "-webkit-appearance": "none",
        },
        "&::-webkit-media-controls-start-playback-button": {
            display: "none",
            "-webkit-appearance": "none",
        },
        "&::-webkit-media-controls-container": {
            display: "none",
            "-webkit-appearance": "none",
        },
    };
    const videoElNoPillarBox = {
        objectFit: "cover",
        top: 0,
        left: "50%",
        position: "relative",
        transform: mirror ? "rotateY(180deg) translate(50%, 0)" : "rotateY(0deg) translate(-50%, 0)",
        transition: "all 0.3s ease-in-out",
    };
    if (pillarBox) {
        videoElement = { ...videoElement, ...videoElPillarBox };
    }
    else {
        videoElement = { ...videoElement, ...videoElNoPillarBox };
    }
    // Root Styles
    const rootFullScreen = {
        overflow: "hidden",
    };
    const rootNotFullScreen = {
        height: "100%",
        backgroundColor: "black",
        "&.preview": {
            position: "relative",
            zIndex: 130,
            "@media only screen and (min-width: 600px)": {
                position: "absolute",
                "&.right": {
                    top: "1rem",
                    right: "1rem",
                    width: "25%",
                },
                "&.left": {
                    top: "1rem",
                    left: "1rem",
                    width: "25%",
                },
            },
        },
    };
    // Styling for fullscreen //
    if (fullScreen) {
        root = { ...root, ...rootFullScreen };
    }
    else {
        root = { ...root, ...rootNotFullScreen };
    }
    const style = {
        root,
        videoElement,
    };
    return style;
};
exports.videoWrapperStyles = videoWrapperStyles;
const styles = (0, exports.videoWrapperStyles)({
    pillarBox: false,
    fullScreen: false,
    mirror: false,
    elementBlur: false,
    blurPixels: 11,
});
exports.default = styles;
//# sourceMappingURL=styles.js.map